import { render, staticRenderFns } from "./UsersAndGroups.vue?vue&type=template&id=5879cbb0&"
import script from "./UsersAndGroups.vue?vue&type=script&lang=js&"
export * from "./UsersAndGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports